'use strict';

exports.__esModule = true;
exports.defaultHeaders = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.url = url;
exports.createHeaders = createHeaders;

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NO_CACHE_HEADERS = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  Pragma: 'no-cache',
  Expires: 0
  /**
   * @access private
   */
};function url(path) {
  return _config2.default.api.API_BASE_URL + path;
}

/**
 * @access private
 */
var defaultHeaders = exports.defaultHeaders = function defaultHeaders() {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Api-Version': _config2.default.api.API_VERSION,
    agent: 'QU/' + _config2.default.api.API_APP_PLATFORM + '/' + _config2.default.api.API_APP_NAME + '/' + _config2.default.api.API_APP_VERSION,
    device_timestamp: new Date().getTime(),
    'X-TimeOffset': _config2.default.timeOffset
  };
};

/**
 * @access private
 */
function createHeaders() {
  var includeAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var formData = arguments[1];
  var overrideHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var authHeader = includeAuth ? (0, _utils.includeAuthHeader)() : {};
  var defHeaders = defaultHeaders();
  var cacheHeaders = _config2.default.cacheFetchHeadersEnabled ? {} : NO_CACHE_HEADERS;

  if (formData) delete defHeaders['Content-Type'];

  (0, _keys2.default)(overrideHeaders).forEach(function (key) {
    defHeaders[key] = overrideHeaders[key];
  });
  return (0, _assign2.default)({}, defHeaders, cacheHeaders, authHeader);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/api-client/utils.js
// module id = 180
// module chunks = 0